export default __webpack_public_path__ + "locales/si/PaymentsEnterprise.json?hash=9d021168ac94a25f13183e1a6ba7f431";